import React, { useCallback } from "react";
import {
  Modal,
  BottomInfoPanel,
  Text,
  Grid,
  Divider,
  Button,
  Icons,
  IconButton,
  Card,
} from "@pushpress/shared-components";
import QRCode from "../../../components/QRcode";
import { copyTextToClipboard } from "../../../utils/copyToClipboard";
import InfoModalCard from "../../../components/modals/InfoModalCard";
import InfoModalHeader from "../../../components/modals/InfoModalHeader";
import styles from "./AppointmentLandingInfoModal.module.scss";

type AppointmentLandingInfoModalProps = {
  appointmentPackage?: {
    uuid: string;
    name: string;
  };
  visible: boolean;
  onClose: VoidFunction;
};

const AppointmentLandingInfoModal = (
  props: AppointmentLandingInfoModalProps,
) => {
  const { onClose, visible } = props;
  return (
    <Modal visible={visible} disablePortal closeModal={onClose}>
      <AppointmentLandingInfoModalContent {...props} />
    </Modal>
  );
};

const AppointmentLandingInfoModalContent = (
  props: AppointmentLandingInfoModalProps,
) => {
  const { appointmentPackage, onClose } = props;

  const url = `${window.location.protocol}//${window.location.hostname}/landing/appointments/${appointmentPackage?.uuid}`;

  const handleCopy = useCallback(() => {
    copyTextToClipboard(url);
  }, [url]);

  return (
    <InfoModalCard>
      <Card.Content>
        <InfoModalHeader onClose={onClose} />
        <Grid container direction="column" columnSpacing={3}>
          <Grid item>
            <Text variant="heading-3">{appointmentPackage?.name}</Text>
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={10}>
                <Button
                  className={styles.linkButton}
                  href={url}
                  buttonType="text"
                  target="_blank"
                  text={url}
                />
              </Grid>
              <Grid item xs={2} container justifyContent="center">
                <IconButton icon={Icons.Copy} onClick={handleCopy} size={22} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            paddingY={2}
            justifyContent="center"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <QRCode url={url} alt={"Appointments QRCore image"} />
            </Grid>
          </Grid>
        </Grid>
        <BottomInfoPanel
          bodyText="Anyone with this URL or QR code will be able to purchase this package."
          buttonText="Learn more"
          buttonLink="https://help.pushpress.com/en/articles/6313509-core-beta-appointments-landing-pages-link-to-website-free-first-appointment/"
        />
      </Card.Content>
    </InfoModalCard>
  );
};

export default AppointmentLandingInfoModal;
